import { HTTPInstanceWithPrefix } from '@/lib/http/http-instance-with-prefix'
import { ImageType } from '@/shared/api/BaseAPI.model'
import {
  languagesListResponseModel,
  categoryPayloadModel,
  categoriesResponseModel,
  dishSizePayloadModel,
  dishSizePutPayloadModel,
  dishSizeResponseModel,
  dishSizesResponseModel,
  languagesListPayloadModel,
  menuTypePayloadModel,
  menuTypePutPayloadModel,
  menuTypeResponseModel,
  menuTypesResponseModel,
  categoryResponseModel,
  categoryPutPayloadModel
} from './SidebarAccordionAPI.model'

class SidebarAccordionAPI {
  // LANGUAGES

  static getLanguageList = (): Promise<languagesListResponseModel> =>
    HTTPInstanceWithPrefix.get('/all-languages').then(response => response.data)

  static getSelectedLangauges = (): Promise<languagesListResponseModel> =>
    HTTPInstanceWithPrefix.get('/languages').then(response => response.data)

  static putLanguages = (
    languageList: languagesListPayloadModel
  ): Promise<languagesListPayloadModel> =>
    HTTPInstanceWithPrefix.put('/languages', languageList).then(
      response => response.data
    )

  // MENU TYPES

  static getMenuTypes = (): Promise<menuTypesResponseModel> =>
    HTTPInstanceWithPrefix.get('/menu-types').then(response => response.data)

  static getMenuType = (menuTypeId: string): Promise<menuTypeResponseModel> =>
    HTTPInstanceWithPrefix.get(`/menu-types/${menuTypeId}`).then(
      response => response.data
    )

  static putMenuType = (
    menuTypeId: string,
    menuTypePayload: menuTypePayloadModel
  ): Promise<menuTypePutPayloadModel> =>
    HTTPInstanceWithPrefix.put(
      `/menu-types/${menuTypeId}`,
      menuTypePayload
    ).then(response => response.data)

  static postMenuType = (
    menuTypePayload: menuTypePayloadModel
  ): Promise<menuTypePayloadModel> =>
    HTTPInstanceWithPrefix.post('/menu-types', menuTypePayload).then(
      response => response.data
    )

  static deleteMenuType = (menuTypeId: string): Promise<string> =>
    HTTPInstanceWithPrefix.delete(`/menu-types/${menuTypeId}`).then(
      response => response.data
    )

  // DISH SIZES

  static getDishSizes = (): Promise<dishSizesResponseModel> =>
    HTTPInstanceWithPrefix.get('/dish-sizes').then(response => response.data)

  static getDishSize = (dishSizeId: string): Promise<dishSizeResponseModel> =>
    HTTPInstanceWithPrefix.get(`/dish-sizes/${dishSizeId}`).then(
      response => response.data
    )

  static putDishSize = (
    dishSizeId: string,
    dishSizePayload: dishSizePayloadModel
  ): Promise<dishSizePutPayloadModel> =>
    HTTPInstanceWithPrefix.put(
      `/dish-sizes/${dishSizeId}`,
      dishSizePayload
    ).then(response => response.data)

  static postDishSize = (
    dishSizePayload: dishSizePayloadModel
  ): Promise<dishSizePayloadModel> =>
    HTTPInstanceWithPrefix.post('/dish-sizes', dishSizePayload).then(
      response => response.data
    )

  static deleteDishSize = (dishSizeId: string): Promise<string> =>
    HTTPInstanceWithPrefix.delete(`/dish-sizes/${dishSizeId}`).then(
      response => response.data
    )

  // CATEGORIES
  static getDishCategories = (): Promise<categoriesResponseModel> =>
    HTTPInstanceWithPrefix.get('/categories').then(response => response.data)

  static getDishCategory = (
    categoryId: string
  ): Promise<categoryResponseModel> =>
    HTTPInstanceWithPrefix.get(`/categories/${categoryId}`).then(
      response => response.data
    )

  static putDishCategory = (
    categoryId: string,
    categoryPayload: categoryPayloadModel
  ): Promise<categoryPutPayloadModel> =>
    HTTPInstanceWithPrefix.put(
      `/categories/${categoryId}`,
      categoryPayload
    ).then(response => response.data)

  static postDishCategory = (categoryPayload: categoryPayloadModel) =>
    HTTPInstanceWithPrefix.post('/categories', categoryPayload).then(
      response => response.data
    )

  static deleteDishCategory = (categoryId: string): Promise<string> =>
    HTTPInstanceWithPrefix.delete(`/categories/${categoryId}`).then(
      response => response.data
    )

  // CATEGORY IMAGES
  // Not implemented by the backend yet, see SidebarAccordion/config.ts for the
  // contract these three are written against.

  static postDishCategoryImage = (
    formData: FormData,
    categoryId: string
  ): Promise<void> =>
    HTTPInstanceWithPrefix.post(`/categories/${categoryId}/images`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(response => response.data)

  static getDishCategoryImage = (categoryId: string): Promise<ImageType> =>
    HTTPInstanceWithPrefix.get(`/categories/${categoryId}/images`).then(
      response => response.data
    )

  static deleteDishCategoryImage = (categoryId: string): Promise<void> =>
    HTTPInstanceWithPrefix.delete(`/categories/${categoryId}/images`).then(
      response => response.data
    )
}
export default SidebarAccordionAPI
